interface OrgLogoProps {
  logoUrl: string
  logoIconUrl?: string | null
  orgName: string
}

// Renders the org logo in the sidebar header. Uses two images so both the
// expanded wordmark and the collapsed square icon are pixel-perfect:
// - expanded: full wordmark (logoUrl), visible while sidebar is wide
// - collapsed: square icon (logoIconUrl) shown instead, hidden when expanded
// Both images are always mounted; CSS toggles which is visible via
// `group-data-[collapsible=icon]` so switching states doesn't flash a reload.
// Falls back to the wordmark if no icon is uploaded.
export function OrgLogo({ logoUrl, logoIconUrl, orgName }: OrgLogoProps) {
  return (
    <div className="flex h-10 w-full items-center justify-start overflow-hidden group-data-[collapsible=icon]:w-8">
      <img
        src={logoUrl}
        alt={`${orgName} logo`}
        className={
          logoIconUrl
            ? "h-8 w-auto max-w-none group-data-[collapsible=icon]:hidden"
            : "h-8 w-auto max-w-none"
        }
      />
      {logoIconUrl ? (
        <img
          src={logoIconUrl}
          alt={`${orgName} icon`}
          className="hidden size-8 object-contain group-data-[collapsible=icon]:block"
        />
      ) : null}
    </div>
  )
}
